export class WidgetConfigurationDTO {

    constructor(
        public phoneNumberRequired: boolean,
        public reserveWithGoogleEnabled: boolean,
        public reserveWithGoogleReasonId: string | null,
        public reserveWithGoogleImportantNote: string | null,
        public reserveWithGoogleAvailabilityDays: number,
        public primaryColour: string | null,
        public pinnedEventId: string | null,
        public dogFriendlyQuestionEnabled: boolean,
        public wheelchairAccessibleQuestionEnabled: boolean,
        public pramAccessibleQuestionEnabled: boolean,
        public highchairFriendlyQuestionEnabled: boolean
    ) { }
}
